import MarkdownWrapper from 'core/components/MarkdownWrapper';

export default function incut(block, parentProps) {
  const {
    theme: {
      controls: {
        vikontIncut: atoms,
      },
    },
  } = parentProps;

  const body = block?.attributes?.body;

  return (
    <div className='incut'>
      <style jsx>{`
        .incut
          font ${atoms.font}
          color ${atoms.color}
          padding ${atoms.padding}
          border-width ${atoms.borderWidth}
          border-color ${atoms.borderColor}
          border-style solid
          text-align ${atoms.textAlign}
      `}</style>
      <MarkdownWrapper>
        {body}
      </MarkdownWrapper>
    </div>
  );
}
